import React, { useEffect, useRef, useState } from "react";

interface InputFieldProps {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  handleSendMessage: () => void;
  loading: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  inputValue,
  setInputValue,
  handleSendMessage,
  loading,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
      adjustTextareaHeight();
    }
  }, []);

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height to recalculate
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevents adding a new line
      handleSend();
    }
  };

  const handleSend = () => {
    handleSendMessage();
    setInputValue(""); // Clear the text area
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset textarea height
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "end",
        padding: "12px 16px",
        background: "#ffffff",
        borderRadius: "16px",
        border: `1px solid ${isFocused ? "#9333ea" : "#e4e4e7"}`,
      }}
    >
      <textarea
        ref={textareaRef}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          adjustTextareaHeight();
        }}
        onKeyDown={handleKeyDown}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder="Ask a question..."
        style={{
          alignSelf: "center",
          flex: 1,
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: "16px",
          color: "#18181b",
          resize: "none", // Prevent manual resizing
          lineHeight: "1.5",
          overflow: "hidden",
        }}
        rows={1}
      />
      <button
        onClick={handleSend}
        disabled={loading || inputValue.trim() === ""}
        style={{
          padding: "12px",
          background:
            inputValue.trim() === ""
              ? "rgba(147, 51, 234, 0.4)"
              : "#9333ea",
          color: "#FFFFFF",
          borderRadius: "12px",
          border: "none",
          cursor:
            inputValue.trim() === "" || loading ? "not-allowed" : "pointer",
        }}
      >
        <img
          src="/external/arrow-up.svg"
          alt="Send"
          style={{ width: "16px", height: "16px" }}
        />
      </button>
    </div>
  );
};

export default InputField;
